export default __webpack_public_path__ + "static/media/Version (2) - Prisoner of Azkaban_01.9528ba79.jpg";